
import Vue from 'vue'
import Component from 'vue-class-component'
import {Watch} from "vue-property-decorator";
import {BoListPanel, BoPanel} from "bonomo/dist";
import {IScreensaver} from "@/model/Screensaver/screensaverInterfaces";
import {BetterDataTableHeader} from "@/model/betterVuetifyInterfaces";
import {namespace} from "vuex-class";
import LinkChip from "@/components/shared/chips/LinkChip.vue";
import {UrlHelper} from "@/helpers/UrlHelper";
import SimpleConfirmationDialog from "@/components/shared/SimpleConfirmationDialog.vue";
import ScreensaverLogs from "@/components/user/logs/ScreensaverLogs.vue";
import BoListFilters from "@/components/shared/BoListFilters.vue";
import CreateButton from "@/components/shared/CreateButton.vue";
import PaginationBar from "@/components/shared/PaginationBar.vue";
import {PAGINATION_PER_PAGE_OPTIONS, PAGINATION_DEFAULT_PER_PAGE} from "@/constants/pagination";


const screensaverModule = namespace("screensaverModule");

@Component({
  components:{
    BoListFilters,
    BoListPanel,
    BoPanel,
    CreateButton,
    LinkChip,
    SimpleConfirmationDialog,
    ScreensaverLogs,
    PaginationBar,
  }
})
export default class ScreensaversList extends Vue {
  @screensaverModule.Getter('screensavers')
  private screensavers!: IScreensaver[];

  @screensaverModule.Getter('currentPage')
  private currentPage!: number;

  @screensaverModule.Getter('lastPage')
  private lastPage!: number;

  @screensaverModule.Getter('total')
  private total!: number;

  @screensaverModule.Getter('perPage')
  private perPage!: number;

  @screensaverModule.Action('fetchScreensaverList')
  private fetchScreensaverList!: (filters: any) => void;

  @screensaverModule.Action('clearScreensavers')
  private clearScreensavers!: () => void;

  @screensaverModule.Action('setScreensaverActive')
  protected setScreensaverActive!: (params: {screensaverId: number, active: boolean}) => any;

  private onlyActive: boolean = false;
  private search: string = '';
  private selectedPerPage: number = PAGINATION_DEFAULT_PER_PAGE;
  private searchTimer: any = null;
  private currentScreensaver: IScreensaver|null = null
  private showConfirmationDialog: boolean = false;

  readonly perPageOptions: number[] = PAGINATION_PER_PAGE_OPTIONS;

  protected get headers(): BetterDataTableHeader[] {
    return  [
      { text: this.$t('common.id'), align: 'start', sortable: true, value: 'id' },
      { text: this.$t('common.name'), align: 'start', value: 'name' },
      { text: this.$t('common.active'), align: 'center', value: 'active' },
      { text: this.$t('common.where'), align: 'center', value: 'shareCta', sortable: false },
      { text: '', align: 'center', value: 'editCta', sortable: false },
    ];
  }

  mounted() {
    this.loadData();
  }

  loadData() {
    this.fetchScreensaverList(this.buildFilters());
  }

  @Watch('search')
  protected onSearchChanged() {
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => this.reload(), 400);
  }

  @Watch('onlyActive')
  protected onOnlyActiveChanged() {
    this.reload();
  }

  private buildFilters(): any {
    const filters: any = {page: 1, perPage: this.selectedPerPage};
    if (this.search) {
      filters.search = this.search;
    }
    if (this.onlyActive) {
      filters.onlyActive = true;
    }
    return filters;
  }

  private reload() {
    this.clearScreensavers();
    this.fetchScreensaverList(this.buildFilters());
  }

  protected onPageChange(page: number) {
    this.clearScreensavers();
    const filters = this.buildFilters();
    filters.page = page;
    this.fetchScreensaverList(filters);
  }

  protected onPerPageChange(value: number) {
    this.selectedPerPage = value;
    this.reload();
  }

  private editUrl(screensaverId: number) {
    return UrlHelper.mayorScreensaverEdit(screensaverId);
  }

  private onToggleScreensaver(item: IScreensaver){
    this.setScreensaverActive({screensaverId: item.id, active: !item.active});
    this.showConfirmationDialog = false;
  }

  private onToggleScreensaverClicked(item: IScreensaver){
    this.showConfirmationDialog = true;
    this.currentScreensaver = item;
  }

  private onCreateButton() {
    this.$router.push({name: 'screensaverCreate', params: {type: 'service_provider_hero'}});
  }

}

